/* Native page scrolling is shared by all studios; no wheel or touch interception. */
(function(){
  'use strict';
  if(window.PCPageScroll)return;
  const header=document.querySelector('.pc-header,.sc-header,[data-sc-header]');
  let frame=0;
  const caps=new Set();
  function watchCap(cap){
    if(cap.observer)cap.observer.disconnect();
    if(!window.IntersectionObserver)return;
    cap.observer=new IntersectionObserver(entries=>{
      const entry=entries[0];cap.element.classList.toggle('is-stuck',!entry.isIntersecting&&entry.boundingClientRect.top<top());
    },{rootMargin:'-'+Math.ceil(top()+1)+'px 0px 0px',threshold:0});
    cap.observer.observe(cap.sentinel);
  }
  function mountCaps(scope=document){
    scope.querySelectorAll('.pcn-sign__steps,.pck-steps,.ccx-progress-nav').forEach(nav=>{
      if(nav.closest('.pc-step-cap'))return;
      const cap=document.createElement('div'),sentinel=document.createElement('i');cap.className='pc-step-cap';sentinel.className='pc-step-sentinel';sentinel.setAttribute('aria-hidden','true');
      nav.before(sentinel,cap);cap.append(nav);
      let node=cap.closest('.pc-flow,.ccx'),color='';
      while(node){color=getComputedStyle(node).backgroundColor;if(color&&color!=='rgba(0, 0, 0, 0)'&&color!=='transparent')break;node=node.parentElement;}
      cap.style.setProperty('--pc-cap-page',color||'#fff9ed');
      const record={element:cap,sentinel,observer:null};caps.add(record);watchCap(record);
    });
  }
  function measure(){
    frame=0;let offset=12;
    if(header){
      let node=header,pinned=false;
      for(let i=0;node&&i<3;i++,node=node.parentElement)if(['sticky','fixed'].includes(getComputedStyle(node).position))pinned=true;
      if(pinned)offset=Math.min(header.getBoundingClientRect().height,innerHeight*.3)+10;
    }
    document.documentElement.style.setProperty('--pc-page-anchor-top',Math.ceil(offset)+'px');
    caps.forEach(cap=>{if(!cap.element.isConnected){cap.observer?.disconnect();caps.delete(cap);}else watchCap(cap);});
  }
  function update(){if(!frame)frame=requestAnimationFrame(measure);}
  function top(){return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--pc-page-anchor-top'))||12;}
  function reveal(root,target){
    if(!target)return;target.setAttribute('tabindex','-1');target.focus({preventScroll:true});
    const desktop=matchMedia('(min-width:960px)').matches;
    const block=desktop?root.querySelector('.pc-studio-workspace,.ccx-workbench'):target;
    if(!block)return;
    const nav=root.querySelector('.pc-step-cap')||root.querySelector('.pcn-sign__steps,.pck-steps,.ccx-progress-nav');
    const offset=top()+(desktop?0:(nav?.offsetHeight||52)+12);
    window.scrollTo({top:Math.max(0,scrollY+block.getBoundingClientRect().top-offset),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
  }
  window.PCPageScroll={update,top,reveal,mountCaps};
  addEventListener('resize',update,{passive:true});
  if(header&&window.ResizeObserver)new ResizeObserver(update).observe(header);
  measure();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mountCaps(),{once:true});else mountCaps();
  document.addEventListener('shopify:section:load',event=>mountCaps(event.target));
})();
